// src/pages/Unauthorized.tsx
import React from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import useSession from "../hooks/useSession";

export default function Unauthorized() {
  const { handleLogout } = useSession();

  return (
    <Box
      sx={{
        position: "fixed", 
        inset: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        display: "grid",
        placeItems: "center",
        bgcolor: "#FAFAFA",
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
          border: "1px solid #eee",
          bgcolor: "#fff",
          boxSizing: "border-box",
        }}
      >
        <Typography variant="h4" fontWeight={700} mb={1}>
          You’re not authorized
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          This account doesn’t have access to this application or report.
        </Typography>

        <Button
          variant="contained"
          onClick={handleLogout}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            py: 1.2,
            fontWeight: 600,
          }}
        >
          Sign in with a different account
        </Button>
      </Paper>
    </Box>
  );
}
